export class CanSkipPaymentResponse {
}
/**
 * Reasons why the estimate payment authorization can be skipped
 */
export var PaymentWaivedReason;
(function (PaymentWaivedReason) {
    /**
     * Billed to user group
     */
    PaymentWaivedReason["BilledToUserGroup"] = "billed_to_user_group";
    /**
     * Cost waiver requested
     */
    PaymentWaivedReason["CostWaiverRequested"] = "cost_waiver_requested";
    /**
     * The user pays for the order after it has been fulfilled but before they can access it.
     */
    PaymentWaivedReason["PayAfterFulfilment"] = "pay_after_fulfilment";
})(PaymentWaivedReason || (PaymentWaivedReason = {}));
/**
 * Reasons why the final payment can be waived
 */
export const FINAL_PAYMENT_WAIVED_REASONS = [
    PaymentWaivedReason.BilledToUserGroup,
    PaymentWaivedReason.CostWaiverRequested,
];
